import ListWithTotal from 'common/dto-types/list-with-total-dto';
import CountryDto from 'common/dto-types/country-dto';
import axiosServices, { PaginationAndFiltersParams, buildQueryParams } from 'utils/axios';
import { AxiosResponse } from 'axios';

export const COUNTRY_API_URL = '/countries';

export const createCountry = async (country: CountryDto): Promise<number | null | undefined> => {
    try {
        return await axiosServices.post(COUNTRY_API_URL, country).then((res) => res.data);
    } catch (err) {
        console.error(err);
        return null;
    }
};

export const deleteCountry = async (id: string): Promise<number | null> => {
    try {
        return await axiosServices.delete(`${COUNTRY_API_URL}/${id}`).then((res) => res.status);
    } catch (err) {
        console.error(err);
        return null;
    }
};

export const fetchCountryList = async (
    params: PaginationAndFiltersParams,
): Promise<ListWithTotal<CountryDto> | null | undefined> => {
    try {
        const res = await axiosServices.get(`${COUNTRY_API_URL}${buildQueryParams(params)}`);
        return res.data;
    } catch (err) {
        // TODO: Implement a proper way to handle errors
        // https://fifadigital.atlassian.net/browse/FMH-2075
        console.error(err);
        return null;
    }
};

export const synchronizeFdcpCountries = async (): Promise<AxiosResponse | null | undefined> => {
    try {
        return await axiosServices.post(`${COUNTRY_API_URL}/syncFdcpCountries/`);
    } catch (err) {
        const errorResponse = err as AxiosResponse;
        if (errorResponse) return errorResponse;
        return null;
    }
};
